import { type Href } from 'expo-router';
import { View } from 'react-native';

import { Button } from '@/components/ui/Button';
import { cn } from '@/components/ui/cn';
import { ProgressBar } from '@/components/ui/ProgressBar';
import { Surface } from '@/components/ui/Surface';
import { Text } from '@/components/ui/Text';

export interface ActiveRunCardProps {
  title: string;
  /** Small mono eyebrow, e.g. "Sailboat · with Mara K." */
  topLeft?: string;
  /** Right-aligned mono note, e.g. "22 min" or "just now". */
  topRight?: string;
  /** Plain status line, e.g. "4 of 12 steps complete · with Mara K." */
  statusLine?: string;
  done: number;
  total: number;
  resumeLabel?: string;
  /** Navigation target for the resume button — renders a real `<a href>` on web. */
  href?: Href;
  onResume?: () => void;
  className?: string;
}

/** The pinned active-run card at the top of Home. */
export function ActiveRunCard({
  title,
  topLeft,
  topRight,
  statusLine,
  done,
  total,
  resumeLabel = 'Resume run',
  href,
  onResume,
  className,
}: ActiveRunCardProps) {
  return (
    <Surface className={cn('gap-3 p-4', className)}>
      {topLeft || topRight ? (
        <View className="flex-row items-center justify-between">
          <Text variant="accent">{topLeft}</Text>
          {topRight ? <Text variant="accent">{topRight}</Text> : null}
        </View>
      ) : null}
      <Text variant="title">{title}</Text>
      {statusLine ? <Text variant="caption">{statusLine}</Text> : null}
      <ProgressBar value={done} total={total} className="my-1" />
      <Button variant="ink" block label={resumeLabel} href={href} onPress={onResume} />
    </Surface>
  );
}
